/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ILinks {
  linkDescription?: string;
  downloadLink?: string;
}

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  links: ILinks[];
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'Ramadan with Geoffrey',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDsCE',
    textDescription:
      'Geoffrey is enjoying Ramadan spirits, what about you kids? Lets get some fun time, just print the sheets and enjoy! Make your own gift card, or help Geoffrey find the missing letters, or get through the maze, go, go, go, print and let the fun starts!<br/><br/>Parents, use #LetsPlaySaudi on social media so we can see how they did it!',
    links: [
      {
        linkDescription: 'DIY & Coloring ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1XsR',
      },
      {
        linkDescription: 'Crosswords ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZZo',
      },
      {
        linkDescription: 'Fill The Missing ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZZp',
      },
      {
        linkDescription: 'Mazes ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZZn',
      },
    ],
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
            <div className='table-container'>
              <table className='table'>
                {this.printPage.links.map((item) => (
                  <tr>
                    <td>{item.linkDescription}</td>
                    <td>
                      <a href={item.downloadLink} className='print-download-link' target='_blank'>download
                      </a>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
